<template>
  <div>
    <v-card dark>
      <v-card-title>
        <div>
          <span class="text-h6">Criar Novo Orçamento</span>
        </div>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formCreateOrder" ref="form">
          <v-row dense>
            <v-col
              cols="6"
              sm="2"
              md="2"
              lg="1"
              v-show="authUser && authUser.guest == null"
            >
              <v-text-field
                placeholder="Código"
                label="Vendedor"
                persistent-hint
                class="text-caption"
                outlined
                dark
                dense
                readonly
                disabled
                v-model="order.vendedor.CODIGO"
              />
            </v-col>
            <v-col cols="6" sm="10" md="5" :lg="isGuest ? 5 : 4">
              <v-autocomplete
                class="text-caption"
                :class="isGuest ? 'ml-2' : ''"
                item-text="DESCRICAO"
                item-value="CODIGO"
                :value="order.empresa"
                :items="getComboBoxListEmp"
                label="Cliente"
                placeholder="Selecione um Cliente"
                clearable
                hide-no-data
                dark
                dense
                outlined
                return-object
                @change="changeCompany"
                @keyup="updateCompanies($event)"
                :disabled="authUser && authUser.guest != null"
              />
            </v-col>
            <v-col cols="6" sm="4" md="5" lg="3">
              <c-select
                item-text="DESCRICAO"
                item-value="CODIGO"
                :lista="getComboBoxListDeps"
                :item.sync="order.departamento"
                rotulo="Departamento"
                v-model="order.departamento"
                @searchinput="updateDepartaments($event)"
                :rules="formRules.notEmpty"
              >
              </c-select>
            </v-col>
            <template v-if="$vuetify.breakpoint.name != 'md'">
              <v-col cols="6" sm="4" md="2">
                <c-input-date
                  label="Data"
                  v-model.trim="order.data"
                  @change="verifyDate($event, 'data')"
                />
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <c-input-date
                  label="Previsão Entrega"
                  v-model.trim="order.previsaoEntrega"
                  @change="verifyDate($event, 'previsaoEntrega')"
                  @click:prepend-inner="openMenuPrevisaoEntrega"
                  prepend-inner-icon="mdi-menu"
                />
              </v-col>
            </template>
          </v-row>
          <v-row dense justify="end">
            <template v-if="$vuetify.breakpoint.name == 'md'">
              <v-col cols="2">
                <c-input-date
                  label="Data"
                  v-model.trim="order.data"
                  @change="verifyDate($event, 'data')"
                />
              </v-col>
              <v-col cols="3">
                <c-input-date
                  label="Previsão Entrega"
                  style="width: 80%"
                  v-model.trim="order.previsaoEntrega"
                  @change="verifyDate($event, 'previsaoEntrega')"
                  @click:prepend-inner="openMenuPrevisaoEntrega"
                  prepend-inner-icon="mdi-menu"
                />
              </v-col>
              <v-spacer></v-spacer>
            </template>
            <v-col cols="6" sm="4" md="2">
              <v-select
                :items="priceTypes"
                item-text="text"
                item-value="value"
                label="Tipo preço"
                class="text-caption ml-1"
                v-model="order.tipoPreco"
                dark
                dense
                outlined
                :disabled="
                  (authUser && authUser.guest != null) || disabledPriceType
                "
              />
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-select
                :items="currenciesList"
                item-text="cifrao"
                item-value="index"
                label="Moeda"
                class="text-caption ml-1"
                v-model="order.moeda"
                dark
                dense
                outlined
                :disabled="authUser && authUser.guest != null"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card dark class="mt-1">
      <v-card-actions>
        <v-spacer v-show="!isGuest" />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="!isGuest"
              class="text-caption mr-1 px-1 py-0"
              color="purple darken-4"
              v-bind="attrs"
              v-on="on"
              small
              @click="$emit('openQuickRegister')"
            >
              <v-icon small>mdi-plus</v-icon>
              <span class="text-overline px-1">Cadastro</span>
            </v-btn>
          </template>
          <span>Cadastro rápido de clientes.</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="green darken-3"
              v-on="on"
              v-bind="attrs"
              @click.prevent="requestNewOrder()"
              small
            >
              <v-icon small>mdi-plus</v-icon>
              <span class="text-overline px-1">Orçamento</span>
            </v-btn>
          </template>
          <span>Abrir um novo orçamento</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!isGuest"
              color="blue"
              dense
              @click="$emit('openLoadOrder')"
              @shortkey="$emit('openLoadOrder')"
              v-shortkey.once="['alt', 'l']"
              small
              v-on="on"
              v-bind="attrs"
            >
              <v-icon small>mdi-download</v-icon>
              <span class="text-overline px-1">Carregar</span>
            </v-btn>
          </template>
          <span>Carregar um orçamento por número ou sequencial</span>
        </v-tooltip>
        <v-spacer />
      </v-card-actions>
    </v-card>
    <departament-select
      :show-dialog="openSelectDialog"
      @close="openSelectDialog = !openSelectDialog"
      @object-pin="objectPinned"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import cSelect from '@/components/shared/base-input/BaseSelect'
import cInputDate from '@/components/shared/base-input/BaseInputDate'
import DepartamentSelect from '@/components/object/departament/Select'

export default {
  components: { cSelect, cInputDate, DepartamentSelect },
  data: () => {
    return {
      formCreateOrder: false,
      openSelectDialog: false,
      formQuickRegisterValid: false,
      dialogFormQuickRegister: false,
      timer: null,
      formRules: {
        notEmpty: [(v) => !!v || 'Este campo é obrigatório.'],
      },
    }
  },
  props: {
    isGuest: {
      type: Boolean,
      default: false,
    },
    disabledPriceType: {
      type: Boolean,
      default: false,
    },
    verifyDate: {
      type: Function,
    },
    priceTypes: {
      type: Array,
      default: () => [],
    },
    openMenuPrevisaoEntrega: {
      type: Function,
    },
  },
  computed: {
    // Auth Module
    ...mapState('authModule', ['authUser']),
    // PDV Balcao Module
    ...mapState('pdvBalcaoModule/orderModule', ['order']),
    // Company Module
    ...mapState('companyModule', ['companyList']),
    // System Module
    ...mapState('systemModule', ['systemList']),
    // Departament Module
    ...mapState('departamentModule', ['departamentList']),

    ...mapGetters({
      currenciesList: 'systemModule/getSystemCurrencies',
      getComboBoxListDeps: 'departamentModule/getComboBoxListDeps',
      getComboBoxListEmp: 'companyModule/getComboBoxList',
    }),
  },
  methods: {
    objectPinned(e) {
      this.openSelectDialog = !this.openSelectDialog
      this.order.departamento = e
    },
    changeCompany(value) {
      this.$emit('changeCompany', value)
    },
    // Company Module
    ...mapActions({
      getCompaniesAPI: 'companyModule/getCompanies',
      getCompany: 'companyModule/getCompany',
    }),
    // Departament Module
    ...mapActions({
      getDepartamentsAPI: 'departamentModule/getDepartaments',
    }),

    // Company Functions
    async updateCompanies($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null

          if (!param || param.trim().length <= 0) return

          let obj = { page: 1 }

          if (param.lastIndexOf('-') == -1) {
            obj.hibrido = param
          } else {
            param = param
              .trim()
              .split('-')[0]
              .trim()

            obj.codigo = parseInt(param)
          }
          this.getDados(obj, 'company')
        }, 600)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    // Departament Functions
    async updateDepartaments($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null

          if (!param || param.trim().length <= 0) return

          let obj = { page: 1 }

          if (param.lastIndexOf('-') == -1) {
            obj.hibrido = param
          } else {
            param = param
              .trim()
              .split('-')[0]
              .trim()

            obj.codigo = parseInt(param)
          }

          this.getDados(obj, 'departament')
        }, 600)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    // Misc functions
    requestNewOrder() {
      this.$refs.form.validate()
      if (this.formCreateOrder) this.$emit('requestNewOrder')
      else console.log('invalid')
    },
    async getDados(payload, tipo) {
      if (tipo === 'departament') {
        await this.getDepartamentsAPI(payload)
        this.searchingItem = false
      } else if (tipo === 'company') {
        await this.getCompaniesAPI(payload)
        this.searchingItem = false
      }
    },
  },
}
</script>

<style>
input::-webkit-datetime-edit {
  min-width: 100%;
  width: 100%;
}
</style>
